import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const Icon3dBoxBottom: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="3d-box-bottom, shaders, model, room"><path d="M11.9998 22.25L20.8766 17.125V6.875L11.9998 1.75L3.12305 6.875V17.125L11.9998 22.25Z" stroke="currentColor" strokeWidth="1.5"/><path d="M3.12305 17.125L11.9998 12M11.9998 12V1.75M11.9998 12L20.8766 17.125" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default Icon3dBoxBottom;
